export var values = {
    color: "rgba(149, 157, 165, 0.2)",
    blur: 24,
    offsetX: 0,
    offsetY: 8,
    spread: 0
};
